import { render, staticRenderFns } from "./Militar.vue?vue&type=template&id=c85f4db8&"
import script from "./Militar.vue?vue&type=script&lang=js&"
export * from "./Militar.vue?vue&type=script&lang=js&"
import style0 from "./Militar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports